import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './dishListMenuItemQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type DishListMenuItemQuery_dishList_DishList_menuItem_MenuItem_featuredPhoto_MenuItemPosPhoto = {
  __typename: 'MenuItemPosPhoto',
  id: number,
  photoUrl?: string | null,
  shareUrl?: string | null
};

export type DishListMenuItemQuery_dishList_DishList_menuItem_MenuItem_featuredPhoto_Photo = {
  __typename: 'Photo',
  id: number,
  photoUrl?: string | null,
  shareUrl?: string | null
};

export type DishListMenuItemQuery_dishList_DishList_menuItem_MenuItem_featuredPhoto =
  | DishListMenuItemQuery_dishList_DishList_menuItem_MenuItem_featuredPhoto_MenuItemPosPhoto
  | DishListMenuItemQuery_dishList_DishList_menuItem_MenuItem_featuredPhoto_Photo
;

export type DishListMenuItemQuery_dishList_DishList_menuItem_MenuItem_location_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  city: string,
  countryName: string,
  eatPopCtaLinkUrl: string,
  eatPopCtaText: string,
  state?: string | null
};

export type DishListMenuItemQuery_dishList_DishList_menuItem_MenuItem_recentUserAvatars_UserAvatar = {
  __typename: 'UserAvatar',
  id: string,
  avatarUrl: string,
  displayName: string
};

export type DishListMenuItemQuery_dishList_DishList_menuItem_MenuItem_restaurant_Restaurant = {
  __typename: 'Restaurant',
  id: number,
  name: string,
  popmenuUrl?: string | null
};

export type DishListMenuItemQuery_dishList_DishList_menuItem_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  description?: string | null,
  displayName: string,
  generatedCategoryName?: string | null,
  generatedDescription?: string | null,
  generatedReviewsSummary?: string | null,
  idAsSlug: string,
  popsCount: number,
  featuredPhoto?: DishListMenuItemQuery_dishList_DishList_menuItem_MenuItem_featuredPhoto | null,
  location?: DishListMenuItemQuery_dishList_DishList_menuItem_MenuItem_location_RestaurantLocation | null,
  recentUserAvatars: Array<DishListMenuItemQuery_dishList_DishList_menuItem_MenuItem_recentUserAvatars_UserAvatar>,
  restaurant: DishListMenuItemQuery_dishList_DishList_menuItem_MenuItem_restaurant_Restaurant
};

export type DishListMenuItemQuery_dishList_DishList = {
  __typename: 'DishList',
  id: number,
  menuItem?: DishListMenuItemQuery_dishList_DishList_menuItem_MenuItem | null
};

export type DishListMenuItemQuery_Query = {
  __typename?: 'Query',
  dishList: DishListMenuItemQuery_dishList_DishList
};


export type DishListMenuItemQueryVariables = Types.Exact<{
  dishListSlug: Types.Scalars['String']['input'];
  menuItemId: Types.Scalars['Int']['input'];
}>;


export type DishListMenuItemQuery = DishListMenuItemQuery_Query;


export const DishListMenuItemDocument = /*#__PURE__*/ document as unknown as DocumentNode<DishListMenuItemQuery, DishListMenuItemQueryVariables>;


/**
 * __useDishListMenuItemQuery__
 *
 * To run a query within a React component, call `useDishListMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useDishListMenuItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDishListMenuItemQuery({
 *   variables: {
 *      dishListSlug: // value for 'dishListSlug'
 *      menuItemId: // value for 'menuItemId'
 *   },
 * });
 */
export function useDishListMenuItemQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DishListMenuItemQuery, DishListMenuItemQueryVariables> & ({ variables: DishListMenuItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DishListMenuItemQuery, DishListMenuItemQueryVariables>(DishListMenuItemDocument, options);
      }
export function useDishListMenuItemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DishListMenuItemQuery, DishListMenuItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DishListMenuItemQuery, DishListMenuItemQueryVariables>(DishListMenuItemDocument, options);
        }
export function useDishListMenuItemSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DishListMenuItemQuery, DishListMenuItemQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DishListMenuItemQuery, DishListMenuItemQueryVariables>(DishListMenuItemDocument, options);
        }
export type DishListMenuItemQueryHookResult = ReturnType<typeof useDishListMenuItemQuery>;
export type DishListMenuItemLazyQueryHookResult = ReturnType<typeof useDishListMenuItemLazyQuery>;
export type DishListMenuItemSuspenseQueryHookResult = ReturnType<typeof useDishListMenuItemSuspenseQuery>;
export type DishListMenuItemQueryResult = ApolloReactCommon.QueryResult<DishListMenuItemQuery, DishListMenuItemQueryVariables>;